import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sparkles, Loader2 } from "lucide-react";
import { endpoints } from "@/api";
import { toast } from "sonner";
import { useI18n } from "@/i18n";

/**
 * AI Suggest button — sends `getContent()` to Gemini and returns
 * a bilingual { title_en, title_ar, summary_en, summary_ar } object.
 * Calls `onSuggested(data)` so the parent can populate fields selectively.
 */
export default function AiSuggestButton({ getContent, onSuggested, testid = "ai-suggest-btn", label }) {
  const { isRTL } = useI18n();
  const [busy, setBusy] = useState(false);

  const go = async () => {
    const content = (getContent?.() || "").trim();
    if (content.length < 20) {
      toast.error(isRTL ? "اكتب محتوى أطول (20 حرف على الأقل)" : "Write longer content (min 20 chars)");
      return;
    }
    setBusy(true);
    try {
      const data = await endpoints.adminAiSuggest(content);
      if (data && (data.title_en || data.title_ar)) {
        onSuggested(data);
        toast.success(isRTL ? "تم اقتراح العنوان والملخص" : "Title & summary suggested");
      } else {
        toast.error(isRTL ? "لم نتمكن من توليد اقتراح" : "Could not generate a suggestion");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || (isRTL ? "تعذّر الاقتراح" : "Suggestion failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={go}
      disabled={busy}
      className="h-8 px-3 text-xs bg-gradient-to-r from-[#C86240] to-[#a04d31] hover:from-[#b15637] hover:to-[#8e4329] text-white rounded-full shadow-sm"
      data-testid={testid}
    >
      {busy ? (
        <Loader2 className="w-3.5 h-3.5 me-1 animate-spin" />
      ) : (
        <Sparkles className="w-3.5 h-3.5 me-1" />
      )}
      {label || (isRTL ? "اقترح العنوان والملخص بالذكاء" : "AI: Suggest title & summary")}
    </Button>
  );
}
